import React, { useState } from 'react'
import { sellerRoutes } from '@src/routes'
import { Linq } from '@src/components/Linq'
import {
  Unstable_Grid2 as Grid,
  Divider,
  IconButton,
  Typography,
} from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { Info } from '@mui/icons-material'
import { FormattedMessage } from 'react-intl'
import { getSellerName } from '@src/utils/searchUtils'
import MarketplaceSellerModal from '@src/components/MarketplaceSellerModal'
import { PdpFieldsFragment } from '@src/queries/PDPQuery.generated'

const useStyles = makeStyles()((theme) => ({
  productPartnerInfoContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  sellerInfo: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightBold,
  },
  verticalDivider: {
    margin: theme.spacing(0, 2),
  },
  infoButton: {
    padding: 0,
    marginLeft: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  trustedInfo: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.typography.pxToRem(14),
  },
  trustedInfoLabel: {
    fontWeight: theme.typography.fontWeightMedium,
  },
}))

interface ProductPartnerProps {
  product: PdpFieldsFragment
}

const NewSrpProductPartnerInfo: React.FC<ProductPartnerProps> = ({
  product,
}) => {
  const { classes } = useStyles()

  const {
    isMarketplace,
    marketplaceSellerId,
    marketplaceOfferId,
    attributes,
    displaySellerName,
  } = product
  const sellerName = displaySellerName
    ? displaySellerName
    : getSellerName(attributes)
  const mPartnerData =
    isMarketplace &&
    !!marketplaceSellerId &&
    !!marketplaceOfferId &&
    !!sellerName

  const [marketplaceModalIsOpen, setMarketplaceModalIsOpen] = useState(false)
  const toggleMarketplaceSellerModalOpen = () => {
    setMarketplaceModalIsOpen((open) => !open)
  }

  if (!mPartnerData) {
    return null
  }

  return (
    <Grid
      container
      className={classes.productPartnerInfoContainer}
      data-testid="product-partner-info"
    >
      <Grid className={classes.sellerInfo}>
        <Typography
          component="span"
          variant="body2"
          className={classes.trustedInfoLabel}
        >
          <FormattedMessage
            id="CONTACT_SELLER_SHIPPED_SOLD"
            defaultMessage="Shipped & Sold By"
          />{' '}
        </Typography>
        <Linq
          {...sellerRoutes.index(sellerName, marketplaceSellerId as string)}
        >
          {sellerName}
        </Linq>
      </Grid>
      <Grid className={classes.verticalDivider}>
        <Divider orientation="vertical" />
      </Grid>
      <Grid className={classes.trustedInfo}>
        <FormattedMessage
          id="CONTACT_SELLER_TRUSTED"
          defaultMessage="A Trusted Marketplace Seller"
        />
        <IconButton
          className={classes.infoButton}
          aria-label="show mPartner marketplace information"
          data-testid="mpartner-info"
          onClick={toggleMarketplaceSellerModalOpen}
          size="large"
        >
          <Info />
        </IconButton>
        {marketplaceModalIsOpen && (
          <MarketplaceSellerModal
            open={marketplaceModalIsOpen}
            onCancel={toggleMarketplaceSellerModalOpen}
          />
        )}
      </Grid>
    </Grid>
  )
}

export default NewSrpProductPartnerInfo
